import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from '../components/userContext';
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import clsx from 'clsx';
import defaultBg from '../images/clv.png';

import { makeStyles, withStyles, lighten } from '@material-ui/core/styles';
import { 
  Button,
  Checkbox,
  FormGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Paper,
  TextField,
  Typography, 
  Grid,

} from '@material-ui/core'
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import AddCircleRoundedIcon from '@material-ui/icons/AddCircleRounded';


const useStyles = makeStyles((theme) => ({
  showError: {
    minWidth: 450, 
    minHeight: 450, 
    margin: '0 auto', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center',
    '@media (max-width:599px)': {
      minWidth: 270, 
      minHeight: 270, 
    },
  },
  errorContent: {
    fontSize: 20, 
    fontWeight: 500, 
    textAlign: 'center', 
    marginBottom: '-20px',
    '@media (max-width:599px)': {
      fontSize: 14,
      marginBottom: '-10px',
      minWidth: 270, 
    },
  },
  container: {
    boxShadow: theme.shadows[4],
    width: '75%', 
    margin: '0 auto',
    minWidth: 275,
    transition: 'all 0.5s ease',
    '@media (max-width:750px)': {
      width: '100%',
      margin: 0,
    }
  },
  cover: {
    width: 'calc(100% - 100px)', 
    position:'relative', 
    left: 100, 
    transition: 'all 0.5s ease',
    '& .MuiIconButton-root:hover': {
      backgroundColor: 'transparent'
    },
    '@media (max-width:750px)': {
      left: 0,
      width: '100%'
    }
  },
  coverExpanded: {
    left: 0,
    width: '100%'
  },
  form: {
    width: '40%',
    minWidth: 350, 
    display: 'flex', 
    alignItems: 'center', 
    flexDirection: 'column', 
    padding: '20px 36px', 
    backgroundColor: 'rgba(26, 26, 26, 0.9)', 
    overflowY: 'auto', 
    position: 'relative', 
    left: '-100px',
    transition: 'all 0.5s ease',
    '& .MuiSvgIcon-root': {
      color: 'rgb(144, 144, 144)'
    },
    '@media (max-width:750px)': {
      minWidth: 275, 
      left: 0,
      padding: '8px 32px', 
    },
  },
  formExpanded: {
    width: '100%',
    left: 0,
    backgroundColor: 'rgba(26, 26, 26, 1)', 
  },
  expandButton: {
    width: 38,
    height: 38,
    position: 'absolute',
    right: 0,
    padding: 0,
    top: 'calc(50% - 19px)',
    zIndex: 1
  },
  textField: {
    width: '100%',
    '& .MuiInputBase-input':{
      fontSize: 15
    },
    '& .MuiSvgIcon-root': {
      width: '0.75em',
      height: '0.75em'
    },
    '& .MuiTypography-body1': {
      fontSize: 14
    },
    '& .Mui-focused': {
      color: 'rgb(163, 102, 255)'
    },
    marginBottom: 12,
    '& .MuiInput-underline:after': {
      borderBottomColor: 'rgb(163, 102, 255)'
    },
    '& .MuiInput-root': {
      color: 'white',
      foontWeight: 300
    }
  },
  button: {
    borderRadius: 0,
    '&:hover': {
      // backgroundColor: 'rgb(163, 102, 255)',
      color: 'rgb(163, 102, 255)'
    }
  }
}));

export default function GameForm() {
  const classes = useStyles();
  const { user, setFetchGames } = useContext(UserContext);
  const [ inputVal, setInputVal ] = useState({name: '', genre: '', release: '', platform: '', singlePlayer: 0, multiplayer: 0, image_url: ''});
  const [ expand, setExpand ] = useState(false)
  const [ open, setOpen] = useState(false);
  let history = useHistory();
  let { itemId } = useParams();
  
  useEffect(() => { 
    const fetchData = async () => {
      if (itemId) {
        const result = await axios.get(`https://backendexample.sanbersy.com/api/data-game/${itemId}`);
        setOpen(Boolean(result.data.id));
        const { id, name, genre, release, platform, singlePlayer, multiplayer, image_url } = result.data; 
        setInputVal({name, genre, release, platform, singlePlayer, multiplayer, image_url}); 
        // setCurIdGames(id);
      } else {
        setOpen(true)
      }
    }
    fetchData();
  },[]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const { name, genre, release, platform, singlePlayer, multiplayer, image_url } = inputVal;

    if (itemId) {
      axios.put(`https://backendexample.sanbersy.com/api/data-game/${itemId}`, 
      {name, genre, release, platform, singlePlayer, multiplayer, image_url}, 
      {headers: {"Authorization" : "Bearer " + user.token}})
      .then(() => setFetchGames(true)
      );
      console.log("ok")
    } else {
      axios.post(`https://backendexample.sanbersy.com/api/data-game`, 
      {name, genre, release, platform, singlePlayer, multiplayer, image_url}, 
      {headers: {"Authorization" : "Bearer " + user.token}})
      .then(() => setFetchGames(true));
    }
    setInputVal({name: '', genre: '', release: null, platform: '', singlePlayer: 0, multiplayer: 0, image_url: ''});
    history.push(`/${user.email}/dashboard/game-editor/list`);
    // setCurIdGames(null);
  }

  const handleChange = (event) => {
    setInputVal({...inputVal, [event.currentTarget.name]: event.currentTarget.value.toString()});
  }

  const handleCheckbox = (event) => {
    let value = event.currentTarget.checked ? 1 : 0
    setInputVal({...inputVal, [event.currentTarget.name]: value});  
  }

  const goBack = () => {
    history.push(`/${user.email}/dashboard/game-editor/list`);
  }

  const handleExpand = () => {
    setExpand(!expand);
  }

  return (
    <>
      {open ?
        <Paper className={classes.container}>
          <div 
            style={{  
              background: inputVal.image_url ? `url(${inputVal.image_url}) center/cover no-repeat rgba(26, 26, 26, 1)` : `url(${defaultBg}) center/82% auto no-repeat rgba(26, 26, 26, 1)`
            }}
            className={clsx(classes.cover, expand && classes.coverExpanded)}
          >
            <IconButton 
              onClick={handleExpand}
              disableFocusRipple
              disableRipple
              className={classes.expandButton}  
            >
              {expand ? <ChevronLeftRoundedIcon style={{fontSize: '1.8rem'}} /> : <ChevronRightRoundedIcon style={{fontSize: '1.8rem'}} />}
            </IconButton>
            <form onSubmit={handleSubmit} className={clsx(classes.form, expand && classes.formExpanded)}>
              {itemId ? 
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 4}}>
                  <span style={{fontSize: 20, fontWeight: 500, marginRight: '12px'}}>
                    Edit Game (Id : {itemId})
                  </span>
                  <EditRoundedIcon fontSize='small'/>
                </div>
              :
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 4}}>
                  <span style={{fontSize: 20, fontWeight: 500, marginRight: '12px'}}>
                    Add New Game
                  </span>
                  <AddCircleRoundedIcon fontSize='small'/>
                </div>
              }
              <TextField
                className={classes.textField}
                // margin="normal"
                required
                id="name"
                name="name"
                label="Name"
                placeholder="E.g. Dota 2, Warcraft etc."
                type="text"
                onChange={handleChange}
                value={inputVal.name}
                autoComplete="name"
                autoFocus
              />
              <TextField
                className={classes.textField}
                // margin="normal"
                required
                id="genre"
                name="genre"
                label="Genre"
                placeholder="E.g. MMORPG, Open World, etc."
                type="text"
                onChange={handleChange}
                value={inputVal.genre}
                autoComplete="genre"
              />
              <TextField
                className={classes.textField}
                // margin="normal"
                required
                id="release"
                name="release"
                label="Release Year"
                placeholder="E.g. 2021, etc."
                type="number"
                InputProps={{inputProps: {min: 1995, max: new Date().getFullYear()}}}
                onChange={handleChange}
                value={inputVal.release}
                autoComplete="release"
              />
              <TextField
                className={classes.textField}
                // margin="normal"
                required
                id="platform"
                name="platform"
                label="Platform"
                placeholder="E.g. Android, Windows, iOS, etc."
                type="text"
                onChange={handleChange}
                value={inputVal.platform}
                autoComplete="platform"
              />
              <FormControl component="fieldset" className={classes.textField} style={{marginBottom: '-8px'}}>
                <FormLabel 
                  component="legend" 
                  style={{color: 'rgba(144, 144, 144, 1)', fontSize: 12}}
                >
                  Game Mode :
                </FormLabel>
                <FormGroup style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 12}}>
                  <FormControlLabel
                    // className={classes.playerModeCheck}
                    control={<Checkbox style={{width: 38, height: 38}} checked={Boolean(inputVal.singlePlayer)} onChange={handleCheckbox} name="singlePlayer" />}
                    label="Single Player"
                  />
                  <FormControlLabel
                    // className={classes.playerModeCheck}
                    control={<Checkbox style={{width: 38, height: 38}} checked={Boolean(inputVal.multiplayer)} onChange={handleCheckbox} name="multiplayer" />}
                    label="Multi Player"
                  />
                </FormGroup>
              </FormControl>
              <TextField
                className={classes.textField}
                // margin="normal"
                required
                id="image_url"
                name="image_url"
                label="Image Url"
                placeholder="E.g. https://i.ytimg.com/vi/6K4T0nGU4pg/maxresdefault.jpg, etc."
                type="text"
                onChange={handleChange}
                value={inputVal.image_url}
                autoComplete="image_url"
              />
              <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                <Button type="submit" className={classes.button}>
                  Submit
                </Button>
                &nbsp;
                <Button onClick={goBack} className={classes.button}>
                  Cancel
                </Button>
              </div>
            </form>
          </div>
        </Paper>
      :
        <>
          <div className={classes.errorContent}>Error! : Id Not Found</div>
          <div 
            className={classes.showError}
            style={{  
              background: `url(${defaultBg}) center/auto 100% no-repeat rgba(30, 30, 30, 0.5)`
            }}
          />
        </>
      }
    </>
  )
}
